// src/components/SelectedOptionsSummary.js
import React, { useEffect } from 'react';
import { useServiceOptions } from '../utils/serviceOptions';
import { useTranslation } from 'react-i18next';

const SelectedOptionsSummary = (props) => {
  const serviceOptions = useServiceOptions();
  const { t } = useTranslation();
  const selectedOptionIds = props.steps?.solutionChoices?.value || [];

  useEffect(() => {
    if (selectedOptionIds.length > 0) {
      console.log('✅ Final selectedOptionIds:', selectedOptionIds);
    }
  }, [selectedOptionIds]);

  const selectedServices = serviceOptions.filter(option =>
    selectedOptionIds.includes(option.id)
  );

  if (selectedServices.length === 0) {
    return <div>{t('pacobot.noSelection')}</div>;
  }

  return (
    <div>
      <strong>{t('pacobot.featuresSelected')}</strong>
      <div style={{ marginTop: '0.5rem' }}>
        {selectedServices.map(opt => (
          <div key={opt.id} style={{ marginBottom: '0.5rem' }}>
            ✅ <strong>{opt.label}:</strong> {opt.description}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedOptionsSummary;